import { useId } from "react";
import {
    GuxFormFieldCheckbox,
    GuxIcon,
    GuxTooltip,
} from "genesys-spark-components-react";
import { ReadOnlyCheckbox } from "features/common/ReadOnlyInput";
import { AiAnswerExplanation } from "./AiScoringMCQOption";
import { useAppSelector } from "app/hooks";
import { selectCanUserViewAiScoringExplanation } from "features/auth/currentUserSlice";
import { useStrings } from "features/i18n/useStrings";
import strings from "../../common/questionComponents/CommonQuestionComponents.strings";
import aiScoringStringsModule from "./AiScoringMCQOption.strings";
import "./AiScoringNAOption.less";

export function AiScoringNAOption({
    checked,
    disabled,
    onChange,
    explanation,
    focusLabelText,
}: {
    checked: boolean;
    disabled: boolean;
    onChange: () => void;
    explanation: string;
    focusLabelText?: string | null;
}) {
    const t = useStrings(strings);
    const aiScoringStrings = useStrings(aiScoringStringsModule);
    const focusLabelId = useId();
    const canViewAiScoringExplanation = useAppSelector(
        selectCanUserViewAiScoringExplanation
    );

    return (
        <>
            <div className="ai-scoring-icon" data-testid="ai-scoring-icon">
                <GuxIcon
                    iconName="restricted/custom/sparkles-solid"
                    screenreader-text={t.labels.aiSuggestedAnswer}
                />
                <GuxTooltip>{t.labels.aiSuggestedAnswer}</GuxTooltip>
            </div>
            <div className="AiScoringNAOption">
                <div className="NAOption">
                    {disabled ? (
                        <ReadOnlyCheckbox
                            checked={checked}
                            label={t.labels.na}
                        />
                    ) : (
                        <GuxFormFieldCheckbox>
                            <input
                                slot="input"
                                type="checkbox"
                                name={t.labels.na}
                                checked={checked}
                                onChange={onChange}
                                className="Clickable"
                                aria-describedby={
                                    focusLabelText ? focusLabelId : undefined
                                }
                            />
                            <label className="Clickable" slot="label">
                                {t.labels.na}
                            </label>
                        </GuxFormFieldCheckbox>
                    )}
                    <div className="ai-answer-details">
                        <div
                            className="ai-suggested"
                            data-testid="ai-suggested-tag"
                        >
                            <span>{aiScoringStrings.labels.aiSuggested}</span>
                        </div>
                        {focusLabelText && (
                            <div className="focus-label-group">
                                <div className="vertical-line" />
                                <div
                                    id={focusLabelId}
                                    className="focus-label"
                                    data-testid="evaluation-focus-label"
                                >
                                    {focusLabelText}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {canViewAiScoringExplanation && (
                    <AiAnswerExplanation explanation={explanation} />
                )}
            </div>
        </>
    );
}
